import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

// Componentes y Páginas
import Ballpit from './components/Ballpit';
import DarkVeil from './components/DarkVeil/DarkVeil';
import Navbar from './components/Navbar/Navbar';
import HomePage from './pages/HomePage';
import ServiciosPage from './pages/ServiciosPage';
import EquipoPage from './pages/EquipoPage';

// Estilos
import './App.css';

function App() {
  const location = useLocation();

  return (
    <div className="App">
      
      {/* Fondo para la Página de Inicio */}
      {location.pathname === '/' && (
        <div className="ballpit-container">
          <Ballpit
            count={70}
            gravity={0.01}
            friction={0.9975}
            wallBounce={0.95}
            followCursor={false}
            colors={[0x6247aa, 0xA0A0A0, 0xFFFFFF, 0x252525]}
          />
        </div>
      )}
      
      {/* --- 👇 CAMBIO IMPORTANTE AQUÍ 👇 --- */}
      {/* Fondo para las páginas de Servicios Y Equipo */}
      {(location.pathname === '/servicios' || location.pathname === '/equipo') && <DarkVeil />}
      
      <div className="content-scroll">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/servicios" element={<ServiciosPage />} />
          <Route path="/equipo" element={<EquipoPage />} />
        </Routes>
      </div>

    </div>
  );
}

export default App;
